import { render, staticRenderFns } from "./Regular.vue?vue&type=template&id=66b39a84"
import script from "./Regular.vue?vue&type=script&lang=js"
export * from "./Regular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports